@if (mergeRequests.length === 0) {
  <p
    class="op-tab-content--text-box"
    [innerHTML]="getEmptyText()"
  ></p>
}

@for (mergeRequest of mergeRequests; track mergeRequest.id || mergeRequest.htmlUrl) {
  <gitlab-merge-request [mergeRequest]="mergeRequest" />
}
